import React, { useState, useEffect } from "react";
// import Hamburger from "./components/Hamburger";
// import HeaderComponents from "./components/HeaderComponents";
import SideNav from "./components/SideNav";
// import Home from "./Home";
import ScrollTopButton from "./components/ScrollTopButton";
import "./AddSource.css";
import BackArrow from "./icons/iconComponents/BackArrow";
import { useNavigate } from "react-router-dom";
import TopicScrollContainer from "./TopicScrollContainer";
// import SvgSearchIcon from "../src/icons/iconComponents/SearchIcon";
import searchIcon from "./icons/search-24px.svg";
import { useTheme } from "./contexts/ThemeContext";
import { SourceSearchModal, AddLinkModal } from "./components/Modal";
import AddSourceContainerWrapper from "./AddSourceContainerWrapper";
import { useMediaQuery } from "react-responsive";
import FullSpanSourceSearchModal from "./components/FullSpanSourceSearchModal";
import environment from "./Environment";
import { commitLocalUpdate } from "react-relay";
import { updateLocalSetting } from "./Environment";

function AddSource(props) {
    const [scrolled, setScrolled] = useState(window.pageYOffset);
    let [coords, setCoords] = useState(document.documentElement.clientHeight);
    const navigate = useNavigate();
    const [isModalActive, setIsModalActive] = useState(false);
    const [selectedSubId, setSelectedSubId] = useState("");
    const [selectedSubName, setSelectedSubName] = useState("");
    const [isSearchModalActive, setIsSearchModalActive] = useState(false);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });

    let [searchValue, setSearchValue] = useState("");
    const {
        isNavActivated,
        isFullSpanSourceSearchModalActivated,
        isAddFeedBoxShown,
        isAddSourcePageActivated,
    } = props.settings;

    // console.log('Box: ' + isAddFeedBoxShown);
    // console.log('Page: ' + isAddSourcePageActivated);

    function onSubmit(e) {
        e.preventDefault();
        // updateLocalSetting("sourceString", searchValue);

        // console.log(props.allSources);
        // console.log("Submited source search!");
    }

    function onChange(e) {
        e.preventDefault();
        setSearchValue(e.target.value);
    }

    function onAddClick(e) {
        e.preventDefault();
        setIsModalActive(true);
        setSelectedSubId(e.target.dataset.id);
        setSelectedSubName(e.target.dataset.name);

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue([e.target.dataset.id], "selectedNodeId");
        });
    }

    function onBackClick(e) {
        e.preventDefault();
        updateLocalSetting("isFullScreenMenuActivated", false);
        updateLocalSetting("isNewFolderView", false);
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isAddSourcePageActivated");
        });
        navigate("/home");
    }

    function onSearchSourceClick(e) {
        e.preventDefault();
        setIsSearchModalActive(true);
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isFullSpanSourceSearchModalActivated");
        });
    }

    function onAddLinkClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isAddFeedBoxShown");
        });
    }

    function setAddFeedBoxShown(value) {
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(value, "isAddFeedBoxShown");
        });
    }

    // useEffect(() => {
    //     commitLocalUpdate(environment, (store) => {
    //         const record = store.getRoot().getLinkedRecord("settings");
    //         record.setValue(true, "isAddSourcePageActivated");
    //     });
    //     return () => {
    //         commitLocalUpdate(environment, (store) => {
    //             const record = store.getRoot().getLinkedRecord("settings");
    //             record.setValue(false, "isAddSourcePageActivated");
    //         });
    //     };
    // });

    let showHeader = scrolled > coords ? "true" : "false";

    return (
        <>
            {isSmallScreen ? (
                <div>
                    <div
                        className={`header header-fixed-true theme-${theme.light}`}
                    >
                        <div
                            className={`detailview-header-room-false theme-${theme.light} theme-${theme.borderBottom}`}
                        >
                            <div
                                className={`addsource-page-header-icon-container theme-${theme.light}`}
                            >
                                <div
                                    className={`addsource-back-icon-false`}
                                    onClick={onBackClick}
                                >
                                    <BackArrow
                                        className={`addsource-back-arrow add-source-back-arrow-false`}
                                    />
                                    {/* <button className="goto-posts-button">Back to posts</button> */}
                                </div>

                                <span className="source-header-controls">
                                    <span
                                        className="source-search-icon"
                                        onClick={onSearchSourceClick}
                                    >
                                        <img
                                            width={24}
                                            src={searchIcon}
                                            alt=""
                                        />
                                        <span
                                            className={`theme-${theme.paragraph}`}
                                        >
                                            Search Sources
                                        </span>
                                    </span>
                                    <span
                                        onClick={onAddLinkClick}
                                        className={`add-link theme-${theme.paragraph}`}
                                    >
                                        Add Link{" "}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`addsource-page-wrapper addsource-page-wrapper-false theme-${theme.light}`}
                    >
                        <div className="addsource-headline-container">
                            <span>
                                <h2 className="meta-headline"> Featured </h2>
                                {/* <h3> Featured</h3> */}
                            </span>
                        </div>
                        <div className="source-container">
                            <div className="category-select">
                                <TopicScrollContainer
                                    user={props.user}
                                    settings={props.settings}
                                />
                            </div>
                            <AddSourceContainerWrapper
                                settings={props.settings}
                                user={props.user}
                            />
                            <div>
                                {isFullSpanSourceSearchModalActivated ? (
                                    <div>
                                        <FullSpanSourceSearchModal
                                            isActivated={true}
                                        />
                                    </div>
                                ) : (
                                    <>
                                        {isAddFeedBoxShown ? (
                                            <div>
                                                <AddLinkModal
                                                    title="Add Link"
                                                    actionButton="Add"
                                                    setIsModalActive={
                                                        setAddFeedBoxShown
                                                    }
                                                    isModalActive={
                                                        isAddFeedBoxShown
                                                    }
                                                />{" "}
                                            </div>
                                        ) : null}
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="source-search-results"></div>
                    </div>
                    <ScrollTopButton />
                </div>
            ) : (
                <div>
                    <div
                        className={`header header-fixed-true theme-${theme.light}`}
                    >
                        <div
                            className={`detailview-header-room-${isNavActivated} theme-${theme.light} theme-${theme.borderBottom}`}
                        >
                            <div
                                className={`addsource-page-header-icon-container theme-${theme.light}`}
                            >
                                <div
                                    className={`addsource-back-icon-${isNavActivated}`}
                                    onClick={onBackClick}
                                >
                                    <BackArrow
                                        className={`addsource-back-arrow add-source-back-arrow-${isNavActivated}`}
                                    />
                                    {/* <button className="goto-posts-button">Back to posts</button> */}
                                </div>

                                <span className="source-header-controls">
                                    <span
                                        className="source-search-icon"
                                        onClick={onSearchSourceClick}
                                    >
                                        <img
                                            width={24}
                                            src={searchIcon}
                                            alt=""
                                        />
                                        <span>Search Sources</span>
                                    </span>
                                    <span
                                        onClick={onAddLinkClick}
                                        className="add-link"
                                    >
                                        Add Link{" "}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <SideNav
                        isActivated={isNavActivated}
                        settings={props.settings}
                        user={props.user}
                    />{" "}
                    <div
                        className={`addsource-page-wrapper addsource-page-wrapper-${isNavActivated} theme-${theme.light}`}
                    >
                        <div className="addsource-headline-container">
                            <span>
                                <h2 className="meta-headline"> Featured </h2>
                                {/* <h3> Featured</h3> */}
                            </span>
                        </div>
                        <div className="source-container">
                            <div className="category-select">
                                <TopicScrollContainer
                                    user={props.user}
                                    settings={props.settings}
                                />
                            </div>
                            <AddSourceContainerWrapper
                                settings={props.settings}
                                user={props.user}
                            />
                            <div>
                                {isSearchModalActive ? (
                                    <div>
                                        {" "}
                                        <SourceSearchModal
                                            title="Search Sources"
                                            actionButton="Search"
                                            setIsModalActive={
                                                setIsSearchModalActive
                                            }
                                            isModalActive={isSearchModalActive}
                                        />{" "}
                                    </div>
                                ) : (
                                    <div>
                                        {isAddFeedBoxShown ? (
                                            <div>
                                                <AddLinkModal
                                                    title="Add Link"
                                                    actionButton="Add"
                                                    setIsModalActive={
                                                        setAddFeedBoxShown
                                                    }
                                                    isModalActive={
                                                        isAddFeedBoxShown
                                                    }
                                                />{" "}
                                            </div>
                                        ) : null}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="source-search-results"></div>
                    </div>
                    <ScrollTopButton />
                </div>
            )}
        </>
    );
}

export default AddSource;
